import type { ReactElement } from 'react'
import { STROKE } from '../glyphs/shared'
import type { Element } from '@origami/shared'

interface ElementGlyphProps {
  element: Element
  size?: number
}

/**
 * Tiny element icon — rendered with currentColor so it tints to whatever
 * text color it inherits. Use inside a .chip or .bg-{element} container
 * to get the right background + foreground combo.
 *
 * Five glyphs match the 5 elements in spec §4.1 (wood, fire, earth,
 * wind, water).
 */
export const ElementGlyph = ({ element, size = 14 }: ElementGlyphProps): ReactElement => {
  switch (element) {
    case 'fire':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size}>
          <path
            d="M12 2 C 14 8 18 8 18 14 a6 6 0 1 1 -12 0 C 6 10 9 10 12 2 Z"
            fill="currentColor"
            stroke={STROKE}
            strokeWidth="1.2"
          />
        </svg>
      )
    case 'water':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size}>
          <path
            d="M12 2 C 16 10 20 14 20 17 a8 8 0 0 1 -16 0 C 4 14 8 10 12 2 Z"
            fill="currentColor"
            stroke={STROKE}
            strokeWidth="1.2"
          />
        </svg>
      )
    case 'wind':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size}>
          <path
            d="M3 8 H15 a3 3 0 1 0 -3 -3 M3 14 H19 a4 4 0 1 1 -4 4"
            stroke="currentColor"
            strokeWidth="2.4"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      )
    case 'wood':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size}>
          <path
            d="M12 3 L12 21 M12 8 L7 5 M12 8 L17 5 M12 13 L6 11 M12 13 L18 11 M12 17 L8 16 M12 17 L16 16"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      )
    case 'earth':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size}>
          <path
            d="M3 18 L9 8 L13 14 L17 10 L21 18 Z"
            fill="currentColor"
            stroke={STROKE}
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
        </svg>
      )
  }
}
